import { render, staticRenderFns } from "./dmsportal.vue?vue&type=template&id=359b8f67"
import script from "./dmsportal.vue?vue&type=script&lang=js"
export * from "./dmsportal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports